import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import BodyClassName from 'react-body-classname'
import { postToLoggingServiceNotAuthenticated } from '../../actions/logging'
import {
  clearStatusText,
  loginUser,
  redirectAuthenticatedUser
} from '../../actions/auth'
import { getRandomBackgroundClass } from '../../utils'
import {
  UnauthenticatedBackground,
  LoginContainer,
  LoginAlignment,
  LoginIcon,
  Logo,
  LockedAccountMessage
} from '../../components/Account/styles'
import { LoginForm } from './styles'
import ForgotPassword from '../../components/Account/ForgotPassword'
import Button from '../../components/mini/Button'
import Copyright from '../../components/mini/Copyright'
import Password from '../../components/mini/Password'
import logo from '../../static/images/branding/quest_logo.svg'
import QFTextImage from '../../static/images/branding/quest_forward_quest.svg'
import { ErrorTypography, Input } from '../../components/styled/typography/typography'

export const Login = ({
  dispatch,
  isAuthenticated,
  isAuthenticating,
  statusText,
  view
}) => {
  const [bgClass] = useState(getRandomBackgroundClass())
  const [email, setEmail] = useState(localStorage.getItem('lastLogin') || '')
  const [password, setPassword] = useState('')
  const [showResetPassword, setShowResetPassword] = useState(view || false)
  const [lockedEmail, setLockedEmail] = useState('')

  useEffect(() => {
    dispatch(clearStatusText())
    // is for case where user is logged in, but reloads /login or root of site
    if (sessionStorage.getItem('oef-token')) {
      dispatch(redirectAuthenticatedUser())
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  const checkForSubmit = e => {
    if (e.which === 13 || e.keyCode === 13) {
      login()
    }
  }

  const handleEmailChange = e => {
    setEmail(e.target.value)
  }

  const handlePasswordChange = e => {
    setPassword(e.target.value)
  }

  const login = () => {
    dispatch(loginUser(email, password))
  }

  useEffect(() => {
    if (statusText) {
      setPassword('')
      setLockedEmail(email)

      const pwd = document.querySelector('.password')
      pwd.value = ''
      pwd.focus()
    }
  }, [statusText])

  const shouldButtonBeDisabled = () => {
    return !email || !password
  }

  const onHideForgotPasswordClick = () => {
    setShowResetPassword(false)
    dispatch(push('/login'))
  }

  const onShowForgotPasswordClick = () => {
    dispatch(clearStatusText())
    setShowResetPassword(true)
    dispatch(push('/login/forgotpassword'))
    dispatch(
      postToLoggingServiceNotAuthenticated('forgot_password', {
        action: 'forgot_password_click',
        email: email
      })
    )
  }

  return (
    <BodyClassName className={`login-route ${bgClass}`}>
      <LoginAlignment statusText={statusText}>
        <UnauthenticatedBackground />
        <LoginContainer statusText={statusText} className="login-container">
          {!isAuthenticated && <Logo src={logo}/>}
          {!showResetPassword ? (
            <div>
              <div className="welcome-back">
                <img
                  src={QFTextImage}
                  alt="Quest Forward&trade; Quest!&trade;"
                  style={{ width: '148px' }}
                />
              </div>
              <LoginForm
                id="frmLogin"
                action="javascript:void(0);"
                error={statusText}
              >
                {statusText === 'Locked' && (
                  <LockedAccountMessage>
                    Your account {lockedEmail} has been temporarily locked due to
                    multiple failed login attempts. Check your email to unlock
                    or tap forgot password below.
                  </LockedAccountMessage>
                )}
                {statusText && (
                  <ErrorTypography className="status-text">
                    {statusText === 'Locked'
                      ? 'Oops! Your username or password was incorrect.'
                      : statusText}
                  </ErrorTypography>
                )}

                {isAuthenticated ? (
                  <div className="loading-container small">
                    <div className='loading'/>
                  </div>
                ) : (
                  <div>
                    <div className="form-row">
                      <LoginIcon className="user-icon" />
                      <Input
                        type="email"
                        onChange={handleEmailChange}
                        onKeyPress={checkForSubmit}
                        placeholder="Username or Email"
                        defaultValue={localStorage.getItem('lastLogin')}
                        autoFocus={
                          !statusText && !localStorage.getItem('lastLogin')
                        }
                      />
                    </div>
                    <div className="form-row lst">
                      <LoginIcon
                        className="lock-icon"
                        style={{ left: '-18px' }}
                      />
                      <Password
                        className="password"
                        onChange={handlePasswordChange}
                        onKeyPress={checkForSubmit}
                        placeholder="Password"
                        autoFocus={
                          statusText !== null ||
                          localStorage.getItem('lastLogin') !== null
                        }
                      />
                    </div>
                    <Button
                      className={`quest-btn btn-a go uncap ${
                        shouldButtonBeDisabled() ? 'disabled' : 'active'
                      }`}
                      onClick={
                        !shouldButtonBeDisabled() && !isAuthenticating
                          ? login
                          : null
                      }
                      text="Sign In"
                      style={{ margin: '20px 0' }}
                    />
                  </div>
                )}

                {!showResetPassword && !isAuthenticated && (
                  <Button
                    className="quest-text-btn-dark"
                    id="forgetYourPassword"
                    onClick={onShowForgotPasswordClick}
                    text="Forgot your password?"
                    style={{
                      position: 'absolute',
                      bottom: '40px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      fontSize: '14px'
                    }}
                  />
                )}
              </LoginForm>
            </div>
          ) : (
            <ForgotPassword
              dispatch={dispatch}
              onReturnClick={onHideForgotPasswordClick}
            />
          )}
          <Copyright />
        </LoginContainer>
      </LoginAlignment>
    </BodyClassName>
  )
}

Login.propTypes = {
  dispatch: PropTypes.func,
  isAuthenticating: PropTypes.bool,
  statusText: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  view: PropTypes.string
}

export const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view,
  isAuthenticating: state.auth.isAuthenticating,
  statusText: state.auth.statusText,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(Login)
